import { E32 } from "../theme/endesga32";
import { pixelTheme } from "../theme/pixel";
import { simplePanelStyle } from "../theme/simplePanel";

// Admin-only — one toggle per flag id this NPC can write (set_flags
// on dialogue options PLUS challenge-entry reward flags). Lets an
// admin flip quest state without playing through. The Reset
// Challenges button (on ChallengePanel) is intentionally separate
// and only wipes completion rows — flags live here.
//
// Server enforces admin pipeline + Admin Mode cheat toggle on the
// `PUT /api/admin/flags/:flag` and `DELETE /api/admin/flags/:flag`
// endpoints; this component is a thin visual wrapper around those.

interface Props {
  flagIds: string[];
  flagState: Record<string, number | null>;
  onToggle: (flag: string, nextOn: boolean) => Promise<void>;
}

export function AdminFlagTogglePanel({ flagIds, flagState, onToggle }: Props) {
  const theme = pixelTheme;

  return (
    <section
      style={{
        ...simplePanelStyle(theme),
        padding: 14,
        display: "flex",
        flexDirection: "column",
        gap: 10,
      }}
    >
      <div
        style={{
          fontFamily: theme.fontDisplay,
          fontSize: 11,
          letterSpacing: theme.letterSpacing,
          color: E32.amber,
        }}
      >
        FLAGS · ADMIN MODE
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
        {flagIds.map((flag) => {
          const value = flagState[flag] ?? null;
          const on = value !== null && value > 0;
          return (
            <label
              key={flag}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                padding: "6px 10px",
                border: `2px solid ${theme.panelEdge}`,
                background: on ? E32.amber : theme.panel,
                color: on ? E32.ink : theme.inkDim,
                cursor: "pointer",
                fontFamily: theme.fontDisplay,
                fontSize: 10,
                letterSpacing: theme.letterSpacing,
              }}
            >
              <input
                type="checkbox"
                checked={on}
                onChange={() => void onToggle(flag, !on)}
              />
              <span>{flag}</span>
            </label>
          );
        })}
      </div>
    </section>
  );
}
